<template>
  <div v-if="vobDocument">
    <template v-if="documentLoading">
      <v-progress-circular
          :size="70"
          :width="7"
          color="primary"
          indeterminate
      ></v-progress-circular>
    </template>
    <template v-else>
      <div>
        <h2 style="display: flex; align-items: center; justify-content: center">
          {{ vobDocument.title }}
          <span v-if="vobDocument.guideKey" v-on:click.stop @click="openGuidesModal(vobDocument.guideKey)" class="guides-question-mark">?</span>
          </h2>
      </div>
      <div>
        <Editor
            :content="vobDocument.content"
        />
      </div>
      <div class="mt-2">
        <v-btn
            class="mr-2"
          color="primary"
          @click="saveDocument"
          :loading="docGenerating"
        >
          {{ languageData.saveAndDownload }}
        </v-btn>
        <v-btn
            color="primary"
            @click="showSaveAndSendVob"
        >
          {{ languageData.saveAndSendBtn }}
        </v-btn>
      </div>
    </template>
    <ModalInfo :hidden-agree-btn="true" :layout="'modalSelectTable'" @clicked="hideModalSendVob"  :show-modal="isShowSendVobDocument">
      <template v-slot:header>
        {{ languageData.sendVob }}
      </template>
      <template v-slot:body>
        <v-row justify="center">
          <v-btn
              color="primary"
              class="button-shadow mr-3"
              @click="showContacts"
          >
            {{ languageData.choosePersonAndSend }}
          </v-btn>
          <v-btn
              color="primary"
              class="button-shadow"
              @click="showEmailForm"
          >
            {{ languageData.labels.typeEmail }}
          </v-btn>
        </v-row>
      </template>
    </ModalInfo>
    <ModalInfo :hidden-agree-btn="true" :layout="'modalSelectTable'" @clicked="hideContacts" :show-modal="isShowChooseContact">
      <template v-slot:body>
        <template>
          {{ languageData.favoriteContacts }}
          <FavoriteContactsTable layout="sendEmail" emailType="vobDocument"></FavoriteContactsTable>
        </template>
      </template>
    </ModalInfo>
    <ModalInfo :hidden-agree-btn="true" :layout="'modalForm'" @clicked="hideEmailForm" :show-modal="isShowDocumentSendEmailModal">
      <template v-slot:header>
        {{ languageData.documents.sendDocument + ' ' + vobDocument.title }}
      </template>
      <template v-slot:body>
        <SendEmailForm :isVobDocument="true"></SendEmailForm>
      </template>
    </ModalInfo>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex"
import Editor from "../../../components/Global/Editor"
import eventBus from "../../../event-bus/eventBus";
import downloadFileHelper from "../../../helpers/downloadFileHelper";
import FavoriteContactsTable from "../../Company/components/FavoriteContacts/FavoriteContactsTable";
import SendEmailForm from "./EmailForm";

export default {
  name: "VobDocument",
  components: {Editor, FavoriteContactsTable, SendEmailForm},
  props: {
  },
  data() {
    return {
      isShowChooseContact: false,
      isShowDocumentSendEmailModal: false,
    }
  },
  computed: {
    ...mapState("vobDocuments", {
      vobDocument: state => state.dataReceive,
      documentLoading: state => state.dataLoading,
      docGenerating: state => state.docGenerating
    }),
    ...mapState("updateVisibleVobDocumentModal", {
      isShowSendVobDocument: state => state.isShowSendVobDocument
    })
  },
  methods: {
    ...mapActions("vobDocuments", ["saveVobDocumentRequest"]),
    ...mapActions("updateVisibleVobDocumentModal", ["updateVisibleSendVobModal", "updateVisibleCreateVobDocumentModal"]),
    ...mapActions("updateVisibleInvoiceSendEmailModal", ["updateVisibleInvoiceSendEmailModal"]),
    ...mapActions("sendDocument", ["prepareDocument"]),
    ...mapActions("updateVisibleDocumentSendEmailModal", ["updateVisibleDocumentSendEmailModal"]),
    ...mapActions("updateVisibleGuideModal", ["updateGuidesModalVisible"]),

    saveDocument() {
      this.saveVobDocumentRequest();
    },
    showSaveAndSendVob() {
      this.updateVisibleSendVobModal(true);
    },
    hideModalSendVob() {
      this.updateVisibleSendVobModal(false);
    },
    showContacts() {
      this.isShowChooseContact = true;
    },
    hideContacts() {
      this.isShowChooseContact = false;
    },
    showEmailForm() {
      this.isShowDocumentSendEmailModal = true;
    },
    hideEmailForm() {
      this.isShowDocumentSendEmailModal = false;
    },
   
    openGuidesModal(guideKey) {
        this.updateGuidesModalVisible({
          isGuidesModalVisible: true,
          guideKey
        });
      },
  },
  mounted() {
    eventBus.$on("saveVobDocumentSuccess", (data) => {
      downloadFileHelper(data);
      eventBus.$emit('filterDocuments');
    });
    eventBus.$on("sendVobDocumentSuccess", () => {
      this.isShowDocumentSendEmailModal = false;
      eventBus.$emit('filterDocuments');
    });
  }
};

</script>

<style scoped>

</style>